
import { axios } from '@/utils/axios'
import { flightCities } from '@/assets/js/data'
import { getAirportName } from '@/assets/js/util'
import { orderStatusMap } from '@/dicts/order'

// 提取行程
export async function checkinTrip (params) {
  try {
    return await axios.post('/api/checkin/extractV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取旅客值机信息
export async function checkinData (params) {
  try {
    return await axios.post('/api/checkin/retrievePassengerV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取座位
export async function retrieveSeat (params) {
  try {
    return await axios.post('/api/checkin/retrieveSeatV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 值机
export async function checkin (params) {
  try {
    return await axios.post('/api/checkin/checkInV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取到达城市天气
export async function weather (params) {
  try {
    return await axios.post('/api/checkin/weatherV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 补打登机牌
export async function reprintBoarding (params) {
  try {
    return await axios.post('/api/checkin/reprintBoardingV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 取消值机
export async function checkinCancel (params) {
  try {
    return await axios.post('/api/checkin/cancelV2', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询值机订单列表
export async function queryCheckinList (params) {
  try {
    const data = await axios({
      url: '/api/userSeatOrder/query',
      method: 'post',
      data: params
    })
    const airport = await flightCities()

    if (data && data.list) {
      data.list.forEach(element => {
        element.statusCn = orderStatusMap[element.status]
        element.depName = getAirportName(airport, element.depCode)
        element.arrName = getAirportName(airport, element.arrCode)
      })

      return data
    } else {
      return Promise.reject(new Error('订单数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 查询值机订单详情
export async function queryCheckinDetail (params) {
  try {
    const data = await axios({
      url: '/api/userSeatOrder/detail',
      method: 'get',
      params
    })
    const airport = await flightCities()

    if (data) {
      data.statusCn = orderStatusMap[data.status]
      data.depName = getAirportName(airport, data.depCode)
      data.arrName = getAirportName(airport, data.arrCode)

      return data
    } else {
      return Promise.reject(new Error('订单数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取在线值机记录
export async function queryCheckinRecord (params) {
  try {
    return await axios.post('/api/checkin/list', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 多人值机
 */

// 添加同行人
export async function handlePartner (params) {
  try {
    return await axios.post('/api/checkin/addPartner', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 多人打印登机牌
export async function multiPrint (params) {
  try {
    return await axios.post('/api/checkin/multiPrint', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 多人值机
export async function multiCheckin (params) {
  try {
    return await axios.post('/api/checkin/multiCheckIn', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
// 添加同行人
export async function checkPassengerTypeRatio (params) {
  try {
    return await axios({
      method: 'post',
      url: '/api/checkin/checkPassengerTypeRatio',
      headers: {
        'passby-consume-token': true
      },
      data: params
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
